import MDinput from '@/components/MDinput';
import { validatorRequire } from '@/utils/validators';
import AddressInput from '@/components/DSE/AddressInput';

export function getFormDefinition(vue) {
  return {
    name: {
      type: MDinput,
      props: {
        maxlength: 64
      },
      rules: [{ validator: validatorRequire }]
    },
    address: {
      type: AddressInput,
      defaultValue: null,
      props: {
        countries: vue.$store.getters['country/loadedItems'],
        countriesLoading: vue.$store.getters['country/isLoading']
      }
    }
  };
}
export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
